import React from 'react';


function SuspensionAndRevocationPolicy() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Suspension and Revocation Policy</h1>

        <div className="space-y-12 text-gray-800">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. Policy Objective</h2>
            <p className="leading-relaxed">
              This policy defines the procedures for altering the status of an operator in the AASC Public Registry when they fail to maintain adherence to the standards or violate the Terms of declaration.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">2. Grounds for Suspension</h2>
            <p className="leading-relaxed mb-4">
              An operator's status may be placed in "Suspended" standing under the following conditions:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Credible reporting of a critical safety incident involving gross negligence.</li>
              <li>Failure to submit required renewal documentation.</li>
              <li>Use of AASC marks on unverified services.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Grounds for Revocation</h2>
            <p className="leading-relaxed mb-4">
              Status may be permanently "Revoked" under the following conditions:
            </p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Confirmed material misrepresentation of facts during the verification process.</li>
              <li>Refusal to remediate identified control failures within the suspension period.</li>
              <li>Legal judgments indicating fraud or willful misconduct.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">4. Public Disclosure</h2>
            <p className="leading-relaxed">
              Changes in status are reflected immediately in the Public Registry. The Council reserves the right to publish the reason for revocation to protect market integrity.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default SuspensionAndRevocationPolicy;